import React,{useState} from 'react';
import {addUserConnection} from '../../../../actions/facilita-api';
import { CommonServices, convertConnectionTypesToServiceType } from '../../../../constants/utils/connectionTypes';
import * as R from 'ramda';
import { useDispatch } from 'react-redux';
import { ServicesEdit } from '../_common/serviceEdit';
// import {} from '../../../../constants/utils/connectionTypes';

export const DossierComunes = ({connectionTypes, userId, user, serviceDatas, isLoading, generateLetters}) => {
	const dispatch = useDispatch();
	const [selectedUserConnection, setSelectedUserConnection] = useState(undefined);
	return (
		<article className="view-calc pt-4 mb-auto">
			<div className="container-fluid">
				<form className="grid-sm grid-sm-min grid-lg-demarche">
					{
						R.sortWith([R.ascend(R.prop('title'))])(Object.values(CommonServices)).map((srv, index) => {
							let progress = serviceDatas.some(s => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
							return (
								<div key={index} className="form-group col col-lg-3 col-xl-2" data-toggle="modal" data-target="#servicesEdit" onClick={(e) => {
									e.preventDefault();
									if(!connectionTypes.some(c => c.connectionType === srv.connectionType)){
										dispatch(addUserConnection(userId, srv));
									}
									setSelectedUserConnection(srv);
								}}>
									<div className={"card card-body text-center picker-card" + (connectionTypes.findIndex(s => s.connectionType === srv.connectionType) !== -1 ? ' active' : '')}>
										<img className="img-fluid mx-auto mt-auto mb-2 h-6 py-1" src={srv.icon} alt={srv.title} />
										<h3 className={"h6 text-uppercase font-weight-bolder container-slim" + (progress === 100 ? '' : ' mx-auto mt-auto')}>{srv.title}</h3>
										<p className={"h5 mt-auto lh-copy" + (progress === 100 ? ' o-0' : '')}>À compléter</p>
										<div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center mt-auto mb-0" + (progress === 100 ? ' bg-white' : ' bg-common 0')}>
											<div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? ' bg-success o-20' : ' gradient-prime o-50')} style={{ width: `${progress}%` }} role="progressbar"></div>
											<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? ' text-success' : ' o-80')} role="progressbar">{progress}%</div>
										</div>
									</div>
								</div>
							)
						})
					}
				</form>
			</div>
			<ServicesEdit selectedUserConnection={selectedUserConnection} user={user} activeUserConnections={connectionTypes} serviceDatas={serviceDatas} isLoading={isLoading} userId={userId} displayComments={false}  disableModifications={true} generateLetters={generateLetters}  />
		</article>
	)
}